




































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
  Inject,
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import {
  InvestmentFeeSchedule,
  AllowedInvestmentAccountTypes,
  InvestmentManagementType
} from "@/shared/types";
import {
  InvestmentFeeScheduleSettingsFormVariant
} from "@/admin/types";
import { cloneDeep } from "lodash";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({ components: { ErrorSummary }})
export default class InvestmentFeeScheduleSettings extends Vue {
  @Inject() $validator: Validator;
  InvestmentManagementType = InvestmentManagementType;
  @Prop() value: InvestmentFeeSchedule[];
  @Prop() allowedInvestmentAccountTypes: AllowedInvestmentAccountTypes;
  @Prop() variant: InvestmentFeeScheduleSettingsFormVariant;

  hasAdvisory = true;
  hasSelfDirected = true;
  hasRiaManaged = true;
  allowPreEnrollment = false;
  feeSchedules: InvestmentFeeSchedule[] = null;
  formVariant: InvestmentFeeScheduleSettingsFormVariant = null;

  drivewealthStore = useDrivewealthStore();

  validateAnnualBasisNonZero = {
    getMessage (field) {
      return `The ${field} field must be $0.00 if the fee annual basis is 0`;
    },
    validate (amount, annualBasis) {
      return parseFloat(annualBasis) !== 0 || parseFloat(amount) === 0;
    }
  };
  validateQuarterlyMinLessThanOrEqualToMax = {
    getMessage (field) {
      return `The ${field} field must be less than or equal to the quarterly max`;
    },
    validate (quarterlyMin, quarterlyMax) {
      // quarterly max is not actually set when it is 0, do not enforce rule here
      if (parseFloat(quarterlyMax) === 0) {
        return true;
      }
      return parseFloat(quarterlyMin) <= parseFloat(quarterlyMax);
    }
  };

  created () {
    this.$validator.extend("validateQuarterlyMinLessThanOrEqualToMax", this.validateQuarterlyMinLessThanOrEqualToMax);
    this.$validator.extend("validateAnnualBasisNonZero", this.validateAnnualBasisNonZero);
    this.feeSchedules = cloneDeep(this.value);
    this.formVariant = cloneDeep(this.variant);
    if (this.isPartnerFormVariant) {
      this.hasAdvisory = this.allowedInvestmentAccountTypes.hasAdvisory;
      this.hasRiaManaged = this.allowedInvestmentAccountTypes.hasRiaManaged;
      this.hasSelfDirected = this.allowedInvestmentAccountTypes.hasSelfDirected;
      this.allowPreEnrollment = this.allowedInvestmentAccountTypes.allowPreEnrollment;
    }
  }

  @Watch("value")
  cloneOnChange (v: InvestmentFeeSchedule[]) {
    this.feeSchedules = cloneDeep(v);
  }

  @Watch("variant")
  onVariantChange (newVariant: InvestmentFeeScheduleSettingsFormVariant) {
    this.formVariant = cloneDeep(newVariant);
  }

  @Watch("allowedInvestmentAccountTypes")
  loadInvestmentTypes (v: AllowedInvestmentAccountTypes) {
    if (this.isPartnerFormVariant) {
      this.hasAdvisory = v.hasAdvisory;
      this.hasRiaManaged = v.hasRiaManaged;
      this.hasSelfDirected = v.hasSelfDirected;
      this.allowPreEnrollment = v.allowPreEnrollment;
    }
  }

  onCheckChanged () {
    this.$emit("onInvestmentTypeChanged", {
      hasAdvisory: this.hasAdvisory,
      hasRiaManaged: this.hasRiaManaged,
      hasSelfDirected: this.hasSelfDirected,
      allowPreEnrollment: this.allowPreEnrollment
    });
  }

  onInput () {
    this.$emit("input", this.feeSchedules);
  }

  get isPartnerFormVariant (): boolean {
    return this.formVariant === InvestmentFeeScheduleSettingsFormVariant.partner;
  }

  get isEmployerFormVariant (): boolean {
    return this.formVariant === InvestmentFeeScheduleSettingsFormVariant.employer;
  }

  get accountTypeHeaderText (): string {
    return this.isPartnerFormVariant ?
      "Allowed Investment Account Type"
      : "Investment Account Type";
  }

  get headerStyle (): string {
    return this.isPartnerFormVariant ?
    "text-center"
    : "text-left";
  }
}
